import { Helpers } from '../../helpers';
import { ICapacityType } from '../../interfaces/icapacity-type';
import { AssetThirdPartyConstraint } from '../asset-third-party-constraint';

export class CapacityTypeBase {
  CapacityTypeId: number;
  Description: string | null;
  Created: Date | null;
  CreatedBy: string | null;
  Updated: Date | null;
  UpdatedBy: string | null;

  AssetThirdPartyConstraints_CapacityType?: Array<AssetThirdPartyConstraint> | null;

  constructor(item?: ICapacityType) {
    if (item) {

      this.CapacityTypeId = item.CapacityTypeId;
      this.Description = item.Description;
      this.Created = item.Created ? new Date(item.Created) : null;
      this.CreatedBy = item.CreatedBy;
      this.Updated = item.Updated ? new Date(item.Updated) : null;
      this.UpdatedBy = item.UpdatedBy;

      this.AssetThirdPartyConstraints_CapacityType = Helpers.createClassArray(AssetThirdPartyConstraint, item.AssetThirdPartyConstraints_CapacityType);
    }
  }
}